import type { ButtonHTMLAttributes } from "react";

type ToggleColor = "accent" | "amber" | "purple";

const COLOR_ON: Record<ToggleColor, string> = {
  accent: "bg-accent-600",
  amber: "bg-amber-500",
  purple: "bg-purple-600",
};

type ToggleProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "type" | "onChange"
> & {
  checked: boolean;
  onChange: (next: boolean) => void;
  color?: ToggleColor;
};

export function Toggle({
  checked,
  onChange,
  color = "accent",
  disabled,
  className = "",
  ...rest
}: ToggleProps) {
  const trackBg = checked ? COLOR_ON[color] : "bg-slate-300 dark:bg-slate-600";
  const knobPos = checked ? "translate-x-4" : "translate-x-0.5";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors disabled:opacity-40 focus:outline-none ${trackBg} ${className}`.trim()}
      {...rest}
    >
      <span
        className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform ${knobPos}`}
      />
    </button>
  );
}
